module.exports = __webpack_public_path__ + "static/assets/8752d83f21cf1275c5bab340ff29fae1.svg";